import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location)
    // .catch(err => err)
}


let RouteList = [{
    path: '/',
    component: resolve => require(['@/views/layout/App.vue'], resolve),
    meta: {
        title: '首页',
        keepAlive: false,
    },
    children: [{
        path: '/',
        name: 'Dashboard',
        meta: {
            title: '首页',
            keepAlive: true
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },

    //个人资料
    Personal.index,
    {
        path: '/',
        name: 'Home',
        meta: {
            title: '首页',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },
    {
        path: '/price_item',
        name: 'priceItem',
        meta: {
            title: '价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/price_item.vue'], resolve),
    },
    {
        path: '/goodsPrice',
        name: 'goodsPrice',
        meta: {
            title: '价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/goodsPrice.vue'], resolve),
    },
    {
        path: '/user_list',
        name: 'userList',
        meta: {
            title: '用户列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/user_list.vue'], resolve),
    },
    {
        path: '/goods_order',
        name: 'goodsOrder',
        meta: {
            title: '影票订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/goods_order.vue'], resolve),
    },
    {
        path: '/cards_order',
        name: 'cardsOrder',
        meta: {
            title: '品城卡订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/cards_order.vue'], resolve),
    },
    // {
    //     path: '/settle_order',
    //     name: 'settleOrder',
    //     meta: {
    //         title: '结算订单',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/site/settle_order.vue'], resolve),
    // },
    {
        path: '/mahua_orders',
        name: 'mahuaOrders',
        meta: {
            title: '点餐订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/mahua_orders.vue'], resolve),
    },
    {
        path: '/local_order',
        name: 'localOrder',
        meta: {
            title: '本地生活订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/local_order.vue'], resolve),
    },
    {
        path: '/oil_orders',
        name: 'oilOrders',
        meta: {
            title: '油卡订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/oil_orders.vue'], resolve),
    },
    {
        path: '/tel_orders',
        name: 'telOrders',
        meta: {
            title: '话费订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/tel_orders.vue'], resolve),
    },
    {
        path: '/goods_orders',
        name: 'goodsorders',
        meta: {
            title: '电商订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/goods_orders.vue'], resolve),
    },

    {
        path: '/user_withdrawal',
        name: 'userWithdrawal',
        meta: {
            title: '用户提现',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/user_withdrawal.vue'], resolve),
    },
    {
        path: '/apl_records',
        name: 'aplRecords',
        meta: {
            title: '线下影城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/apl_records.vue'], resolve),
    },
    {
        path: '/movie_card',
        name: 'movieCard',
        meta: {
            title: '我的影城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/mine_cards.vue'], resolve),
    },
    {
        path: '/mine_account',
        name: 'mineAccount',
        meta: {
            title: '我的账户',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/account.vue'], resolve),
    },
    {
        path: '/mine_data',
        name: 'mineData',
        meta: {
            title: '站点资料',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/mineData.vue'], resolve),
    },
    {
        path: '/open_card',
        name: 'openCard',
        meta: {
            title: '线上品城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/open_card.vue'], resolve),
    },
    {
        path: '/kefu',
        name: 'kefu',
        meta: {
            title: '客服中心',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/kefu.vue'], resolve),
    },
    {
        path: '/coupon',
        name: 'coupon',
        meta: {
            title: '优惠券',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/coupon.vue'], resolve),
    },
    {
        path: '/addCoupon',
        name: 'addCoupon',
        meta: {
            title: '新建劵',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/addCoupon.vue'], resolve)
    },
    {
        path: '/coupon_detail',
        name: 'coupon_detail',
        meta: {
            title: '优惠劵详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/coupon_detail.vue'], resolve)
    },
    {
        path: '/couponFf',
        name: 'couponFf',
        meta: {
            title: '优惠券投放',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/coupon_ff.vue'], resolve),
    },
    {
        path: '/coupon_records',
        name: 'coupon_records',
        meta: {
            title: '券码记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/coupon_records.vue'], resolve),
    },
    {
        path: '/act_h5_coupon',
        name: 'act_h5_coupon',
        meta: {
            title: 'H5活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act_h5_coupon.vue'], resolve),
    },
    {
        path: '/act_miniapp_coupon',
        name: 'act_miniapp_coupon',
        meta: {
            title: '小程序活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act_miniapp_coupon.vue'], resolve),
    },
    {
        path: '/push',
        name: 'push',
        meta: {
            title: '公众号推文',
            keepAlive: false,
        },
        component: resolve => require(['@/views/push/push.vue'], resolve),
    },
    {
        path: '/weibo',
        name: 'weibo',
        meta: {
            title: '微博推文',
            keepAlive: false,
        },
        component: resolve => require(['@/views/push/weibo.vue'], resolve),
    },
    {
        path: '/patch',
        name: 'patch',
        meta: {
            title: '贴片管理',
            keepAlive: false,
        },
        component: resolve => require(['@/views/push/patch.vue'], resolve),
    },
    {
        path: '/recharge',
        name: 'recharge',
        meta: {
            title: '充值',
            keepAlive: false,
        },
        component: resolve => require(['@/views/recharge/recharge.vue'], resolve),
    },
    {
        path: '/tags',
        name: 'tags',
        meta: {
            title: '标签统计',
            keepAlive: false,
        },
        component: resolve => require(['@/views/account/tags.vue'], resolve),
    },
    {
        path: '/subAccount',
        name: 'subAccount',
        meta: {
            title: '子账号管理',
            keepAlive: false,
        },
        component: resolve => require(['@/views/account/subAccount.vue'], resolve),
    },
    {
        path: '/bindOfficial',
        name: 'bindOfficial',
        meta: {
            title: '绑定公众号',
            keepAlive: false,
        },
        component: resolve => require(['@/views/account/bindOfficial.vue'], resolve),
    },
    {
        path: '/business_list',
        name: 'business_list',
        meta: {
            title: '商家管理',
            keepAlive: false,
            activeMenu: '/business_list'
        },
        component: resolve => require(['@/views/local/business_list.vue'], resolve),
    },
    {
        path: '/business_edit',
        name: 'business_edit',
        meta: {
            title: '商家信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/business_edit.vue'], resolve),
    },
    {
        path: '/inSettlement_list',
        name: 'inSettlement_list',
        meta: {
            title: '结算中',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/inSettlement_list.vue'], resolve),
    },
    {
        path: '/store_list',
        name: 'store_list',
        meta: {
            title: '门店管理',
            keepAlive: false,
            activeMenu: '/business_list'
        },
        component: resolve => require(['@/views/local/store_list.vue'], resolve),
    },
    {
        path: '/store_edit',
        name: 'store_edit',
        meta: {
            title: '门店信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/store_edit.vue'], resolve),
    },
    {
        path: '/member_list',
        name: 'member_list',
        meta: {
            title: '成员管理',
            keepAlive: false,
            activeMenu: '/business_list'
        },
        component: resolve => require(['@/views/local/member_list.vue'], resolve),
    },
    {
        path: '/goods_list',
        name: 'goods_list',
        meta: {
            title: '商品管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/goods_list.vue'], resolve),
    },
    {
        path: '/goods_edit',
        name: 'goods_edit',
        meta: {
            title: '商品信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/goods_edit.vue'], resolve),
    },
    {
        path: '/localOrder',
        name: 'localOrder',
        meta: {
            title: '本地生活订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/local_order.vue'], resolve),
    },
    {
        path: '/price_template',
        name: 'price_template',
        meta: {
            title: '电影票价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/price_template.vue'], resolve),
    },
    {
        path: '/userShare',
        name: 'userShare',
        meta: {
            title: '用户分佣',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/userShare.vue'], resolve),
    },
    {
        path: '/payConfig',
        name: 'payConfig',
        meta: {
            title: '收款配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/payConfig.vue'], resolve),
    },
    {
        path: '/jd_price_template',
        name: 'jd_price_template',
        meta: {
            title: '京东价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/jd_price_template.vue'], resolve),
    },
    {
        path: '/banner',
        name: 'banner',
        meta: {
            title: '首页banner',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/banner.vue'], resolve),
    },
    {
        path: '/index',
        name: 'index',
        meta: {
            title: '首页概览',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/index.vue'], resolve),
    },
    {
        path: '/myMiniPrograms',
        name: 'myMiniPrograms',
        meta: {
            title: '我的小程序',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/myMiniPrograms.vue'], resolve),
    },
    {
        path: '/authMiniPrograms',
        name: 'authMiniPrograms',
        meta: {
            title: '我的小程序',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/authMiniPrograms.vue'], resolve),
    },
    {
        path: '/templates',
        name: 'templates',
        meta: {
            title: '模板选择',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/templates.vue'], resolve),
    },
    {
        path: '/registration',
        name: 'registration',
        meta: {
            title: '小程序注册',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/registration.vue'], resolve),
    },
    {
        path: '/saasCertification',
        name: 'saasCertification',
        meta: {
            title: '小程序注册',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/certification.vue'], resolve),
    },
    {
        path: '/publish',
        name: 'publish',
        meta: {
            title: '发布管理',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/publish.vue'], resolve),
    },
    {
        path: '/checklist',
        name: 'checklist',
        meta: {
            title: '检查清单',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/checklist.vue'], resolve),
    },
    {
        path: '/certificationAndFiling',
        name: 'certificationAndFiling',
        meta: {
            title: '认证及备案',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/com/certificationAndFiling.vue'], resolve),
    },
    {
        path: '/illegalRecords',
        name: 'illegalRecords',
        meta: {
            title: '违规处罚',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/illegalRecords.vue'], resolve),
    },
    {
        path: '/miniProgram',
        name: 'miniProgram',
        meta: {
            title: '微信小程序',
            keepAlive: true
        },
        component: resolve => require(['@/views/saas/miniProgram.vue'], resolve),
    },
    {
        path: '/miniProgram_register',
        name: 'miniProgram_register',
        meta: {
            title: '微信小程序注册',
            keepAlive: false
        },
        component: resolve => require(['@/views/saas/miniProgram_register.vue'], resolve),
    },
    {
        path: '/quick_registr',
        name: 'quick_registr',
        meta: {
            title: '快速创建小程序',
            keepAlive: false
        },
        component: resolve => require(['@/views/saas/quick_registr.vue'], resolve),
    },
    {
        path: '/certification',
        name: 'certification',
        meta: {
            title: '实名认证',
            keepAlive: false
        },
        component: resolve => require(['@/views/saas/certification.vue'], resolve),
    },
    {
        path: '/basicInformation',
        name: 'basicInformation',
        meta: {
            title: '基本信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/saas/basicInformation.vue'], resolve),
    },
    {
        path: '/developmentSettings',
        name: 'developmentSettings',
        meta: {
            title: '开发设置',
            keepAlive: false
        },
        component: resolve => require(['@/views/saas/developmentSettings.vue'], resolve),
    },
    {
        path: '/meituan_order',
        name: 'meituan_order',
        meta: {
            title: '美团订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/meituan_order.vue'], resolve),
    },
    {
        path: '/tuike_order',
        name: 'tuike_order',
        meta: {
            title: '推客订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/tuike_order.vue'], resolve),
    },
    {
        path: '/tuike_config',
        name: 'tuike_config',
        meta: {
            title: '推客配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_config.vue'], resolve),
    },
    // 推客管理
    {
        path: '/twitterUser',
        name: 'twitterUser',
        meta: {
            title: '推客管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/twitterUser.vue'], resolve),
    },
    // 合作店铺
    {
        path: '/tuikeShop',
        name: 'tuikeShop',
        meta: {
            title: '合作店铺',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuikeShop.vue'], resolve),
    },
    // 合作达人
    {
        path: '/tuike_expert',
        name: 'tuike_expert',
        meta: {
            title: '合作达人',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_expert.vue'], resolve),
    },
    // 合作视频
    {
        path: '/tuike_video',
        name: 'tuike_video',
        meta: {
            title: '合作视频',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_video.vue'], resolve),
    },
    // 视频号直播
    {
        path: '/tuike_live',
        name: 'tuike_live',
        meta: {
            title: '视频号直播',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_live.vue'], resolve),
    },
    // 选品广场
    {
        path: '/tuike_product_goods',
        name: 'tuike_product_goods',
        meta: {
            title: '选品广场',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_product_goods.vue'], resolve),
    },
    // 商品分类
    {
        path: '/tuike_goods_class',
        name: 'tuike_goods_class',
        meta: {
            title: '商品分类',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_goods_class.vue'], resolve),
    },
    // 商品管理
    {
        path: '/tuike_goods',
        name: 'tuike_goods',
        meta: {
            title: '商品管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_goods.vue'], resolve),
    },
    // 推客订单
    {
        path: '/tuike_order',
        name: 'tuike_order',
        meta: {
            title: '推客订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_order.vue'], resolve),
    },
    // 商品活动
    {
        path: '/tuike_activity',
        name: 'tuike_activity',
        meta: {
            title: '商品活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_activity.vue'], resolve),
    },
    // 标签管理
    {
        path: '/tuike_label',
        name: 'tuike_label',
        meta: {
            title: '标签管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_label.vue'], resolve),
    },
    // 合作
    {
        path: '/tuike_coopera',
        name: 'tuike_coopera',
        meta: {
            title: '合作',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_coopera.vue'], resolve),
    },
    // 数据看板
    {
        path: '/tuike_databoard',
        name: 'tuike_databoard',
        meta: {
            title: '数据看板',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_databoard.vue'], resolve),
    },
    // banner
    {
        path: '/tuike_banner',
        name: 'tuike_banner',
        meta: {
            title: 'banner',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_banner.vue'], resolve),
    },
    // 分享海报
    {
        path: '/tuike_poster',
        name: 'tuike_poster',
        meta: {
            title: '分享海报',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_poster.vue'], resolve),
    },
    // 订单
    {
        path: '/tuike_order',
        name: 'tuike_order',
        meta: {
            title: '推客订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_order.vue'], resolve),
    },
    // 提现配置
    {
        path: '/tuike_tx',
        name: 'tuike_tx',
        meta: {
            title: '提现配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tuike_tx.vue'], resolve),
    },
    // 用户提现
    {
        path: '/tx_order',
        name: 'tx_order',
        meta: {
            title: '用户提现',
            keepAlive: false
        },
        component: resolve => require(['@/views/tuike/tx_order.vue'], resolve),
    },
    // 洗车订单
    {
        path: '/car_order',
        name: 'car_order',
        meta: {
            title: '洗车订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/car_order.vue'], resolve),
    },
    // 洗车价格模板
    {
        path: '/car_template',
        name: 'car_template',
        meta: {
            title: '洗车价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/car_template.vue'], resolve),
    },
    // 点餐价格模板
    {
        path: '/mahua_template',
        name: 'mahua_template',
        meta: {
            title: '点餐价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/mahua_template.vue'], resolve),
    },
    // 影视会员价格模板
    {
        path: '/yshy_template',
        name: 'yshy_template',
        meta: {
            title: '影视会员价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/yshy_template.vue'], resolve),
    },
    // 小程序装修
    {
        path: '/diyDrag',
        name: 'diyDrag',
        meta: {
            title: '小程序装修',
            keepAlive: false
        },
        component: resolve => require(['@/views/saasDiy/diyDrag.vue'], resolve),
    },
    // 小程序装修
    {
        path: '/newDiy',
        name: 'newDiy',
        meta: {
            title: '小程序装修',
            keepAlive: false
        },
        component: resolve => require(['@/views/saasDiy/newDiy.vue'], resolve),
    },
    {
        path: '/wallet_list',
        name: 'wallet_list',
        meta: {
            title: '福利卡',
        },
        component: resolve => require(['@/views/wallet/wallet_list.vue'], resolve)
    },
    {
        path: '/wallet_shelf',
        name: 'wallet_shelf',
        meta: {
            title: '福利卡批次',
        },
        component: resolve => require(['@/views/wallet/wallet_shelf.vue'], resolve)
    },
    {
        path: '/cake_order',
        name: 'cake_order',
        meta: {
            title: '蛋糕订单',
        },
        component: resolve => require(['@/views/order/cake_order.vue'], resolve)
    },
    ]
},
{
    path: '/login',
    name: 'Login',
    meta: {
        title: '登录',
        keepAlive: false
    },
    components: {
        blank: resolve => require(['@/views/login/Login.vue'], resolve),
    },
},

{
    path: '/*',
    name: 'NotFound',
    meta: {
        title: '404',
        keepAlive: true
    },
    components: {
        blank: resolve => require(['@/views/error/404.vue'], resolve),
    }
}
]

export default new Router({
    routes: RouteList
})